import React from 'react';
import { Justify } from 'ksnm-common-ui/lib/Table2/Table.interface';
import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { AGGREGATE } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import type { CellValue, ColumnInterface, RenderParam } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { moneyRender } from '@src/utils/numberUtils';

import styles from '../DataControl.module.scss';

// const onClick = (data: DataSourceRow) => {
//   const { addBreadcrumbs, addPage, lastPagesParam } = dataControlStore;
//
//   const codeGame = data.analytic_1 ? data.analytic_1 + (data.analytic_1_add1 ? ` - ${data.analytic_1_add1}` : '') : '';
//
//   addBreadcrumbs([data.analytic_1 as string]);
//   addPage([
//     {
//       controlType: 'errorDetails',
//       packageCode: data.report_package_code_cm as string,
//       control: lastPagesParam.control,
//       step: lastPagesParam.step,
//       stepName: lastPagesParam.stepName,
//       stepDescription: lastPagesParam.stepDescription,
//       codeGame,
//       controlDescription: lastPagesParam.controlDescription,
//       ctrlName: lastPagesParam.ctrlName,
//       execNum: data.exec_num as string,
//       maxExecNum: lastPagesParam.maxExecNum,
//       user: lastPagesParam.user,
//       time: lastPagesParam.time,
//       filters: [
//         [
//           {
//             name: 'report_package_code_cm',
//             type: FILTER.EQ,
//             values: [data.report_package_code_cm as string],
//             filterIsInverted: false,
//           },
//           {
//             name: 'ctrl_vers',
//             type: FILTER.EQ,
//             values: [data.ctrl_vers as string],
//             filterIsInverted: false,
//           },
//           {
//             name: 'step_num',
//             type: FILTER.EQ,
//             values: [data.step_num as string],
//             filterIsInverted: false,
//           },
//           {
//             name: 'analytic_1',
//             type: FILTER.EQ,
//             values: [data.analytic_1 as string],
//             filterIsInverted: false,
//           },
//         ],
//       ],
//     },
//   ]);
// };

export const columns: ColumnInterface[] = [
  {
    title: 'Код игры',
    key: 'analytic_1',
    width: 130,
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Наименование игры',
    key: 'analytic_1_add1',
    width: 300,
  },
  {
    title: 'Номинал',
    key: 'analytic_2',
    width: 250,
    render: ({ data, value }: RenderParam): CellValue => {
      if (!data.analytic_3) return value;
      return '';
    },
  },
  {
    title: 'Номер тиража',
    key: 'analytic_2_add1',
    width: 250,
    render: ({ data }: RenderParam): CellValue => {
      if (data.analytic_3) return data.analytic_2;
      return '';
    },
  },
  {
    title: 'Дата тиража',
    key: 'analytic_3',
    width: 250,
  },
  {
    title: 'Сравниваемое значение 1',
    key: 'amount_1',
    justify: Justify.RIGHT,
    aggregate: AGGREGATE.SUM,
    render: ({ value }) => moneyRender({ value: Number(value) } as RenderParam),
    width: 250,
  },
  {
    title: 'Сравниваемое значение 2',
    key: 'amount_2',
    justify: Justify.RIGHT,
    aggregate: AGGREGATE.SUM,
    render: ({ value }) => moneyRender({ value: Number(value) } as RenderParam),
    width: 250,
  },
  {
    title: 'Расхождение',
    key: 'delta',
    width: 250,
    aggregate: AGGREGATE.SUM,
    justify: Justify.RIGHT,
    render: ({ data, value }: RenderParam): CellValue => {
      const v = moneyRender({ value: Number(value) } as RenderParam);

      return data.status === 'F' ? <div className={styles.link}>{v}</div> : v;
    },
  },
  {
    title: 'Допустимое расхождение',
    key: 'delta_max',
    width: 250,
    render: ({ value }) => moneyRender({ value: Number(value) } as RenderParam),
    aggregate: AGGREGATE.SUM,
    justify: Justify.RIGHT,
  },
  {
    title: 'Отладка вычисления',
    key: 'res_text',
    justify: Justify.CENTER,
    width: 250,
  },
  {
    key: 'report_package_code_cm',
    hidden: true,
  },
  {
    key: 'ctrl_vers',
    hidden: true,
  },
  {
    key: 'step_num',
    hidden: true,
  },
  {
    key: 'status',
    hidden: true,
  },
  {
    key: 'exec_num',
    hidden: true,
  },
];
